import { FaBars } from 'react-icons/fa';
import { NavLink as Link } from 'react-router-dom';
import styled from 'styled-components';

export const Nav = styled.nav`
  background: #7177A8;
  height: 80px;
  display: flex;
  justify-content: center;
  z-index: 10;
  text-align: center;
  font-size: 11px;
  @media screen and (max-width: 720px) {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
    transition: 1s;
    transform: translateY(-101vh);
  }
`;

export const NavLink = styled(Link)`
  color: #fff;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  cursor: pointer;
  &:hover {
    color: #e7e7e7;
  }
  @media screen and (max-width: 720px) {
    padding: 1rem;
  }
`;

export const Bars = styled(FaBars)`
  display: none;
  color: #192673;
  @media screen and (max-width: 720px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 75%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;

export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  margin-right: -24px;
  @media screen and (max-width: 720px) {
    flex-direction: column;
  }
`;

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;
  margin-right: 24px;
  @media screen and (max-width: 720px) {
    display: none;
  }
`;

export const NavBtnLink = styled(Link)`
  border-radius: 40px;
  padding: 10px 22px;
  color: #fff;
  border: 1px solid white;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  /* Second Nav */
  margin-left: 24px;
  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #7177A8;
  }
`;
